// Mesquite Mafia: Character Entities & Dossier Visualizer
import { state, log, switchTab, enterGame, updateCurrencies } from '../core/state.js';
import { playSFX, playVoiceBark } from '../core/audio.js';
import { playActionSequence } from '../core/kinematics.js';
import { closePlayerSignupModal } from '../services/api.js';
import { hydrateMissionsFromSaved } from '../engine/missions.js';

export let selectedDossierId = 'fat_twin';

export const SYNDICATE_CHARACTERS = {
      boss: {
        id: "boss",
        name: "My Syndicate Boss",
        callsign: "The Mastermind",
        role: "Supreme Syndicate Commander • Room 114 Don",
        category: "player",
        archetype: "enforcer",
        threatTier: "CLASS V: SYNDICATE SUPREME",
        threatClass: "boss",
        avatar: "art/characters/fat_twin.jpg",
        quote: "Mesquite belongs to whoever has the steel to take it and the ledger to hold it.",
        stats: {
          attack: 90,
          defense: 88,
          intel: 85,
          agility: 80,
          influence: 92
        },
        skillActive: {
          name: "Syndicate Mobilization",
          cd: "15.0s (Ultimate)",
          desc: "Surges active district convoys and garrison units forward. Increases combat strike damage by +30% and cash laundering velocity by +25%."
        },
        skillPassive: {
          name: "Room 114 Iron Will",
          desc: "Grants +1.5% bonus damage and damage reduction for every Compound Tier unlocked in Room 114."
        },
        loadout: {
          weapon: "Custom Engraved Desert .50 Handgun",
          armor: "Reinforced Kevlar Tactical Executive Vest",
          accessory: "24k Franco Gold Chain & Black Card"
        },
        dossier: {
          stronghold: "Room 114 Operations Center (US-80 Frontage)",
          warrants: "Federal Racketeering, Interstate Distro Conspiracy, Unregistered Syndicate Treasury.",
          tacticalNotes: "Adaptable operator capable of switching specializations between Bruiser, Smuggler, Kingpin, and Biker to exploit hostile vulnerabilities."
        }
      },
      fat_twin: {
        id: "fat_twin",
        name: "Micah (\"Fat Twin\")",
        callsign: "The Heavy Anchor",
        role: "Syndicate Co-Founder • Chief Enforcer & Bruiser Kingpin",
        category: "ally",
        archetype: "bruiser",
        threatTier: "CLASS IV: IMMOVABLE ANCHOR",
        threatClass: "ally",
        avatar: "art/characters/fat_twin.jpg",
        quote: "They think because I'm smiling that I won't swing this sledge. Room 114 is fortress ground.",
        stats: {
          attack: 88,
          defense: 98,
          intel: 82,
          agility: 52,
          influence: 91
        },
        skillActive: {
          name: "Hometown Stonewall",
          cd: "14.0s (Ultimate)",
          desc: "Deploys a 35% Max HP kinetic barrier for 7.0s and taunts all hostile gunfire in the lane onto himself."
        },
        skillPassive: {
          name: "The Sledge Counter",
          desc: "When kinetic shield absorbs damage, counters attacker with a hydraulic sledge blow for 2.6x DMG and a 3.5s stun."
        },
        loadout: {
          weapon: "Heavy Hydraulic Sledgehammer",
          armor: "Purple Vikings Varsity Jacket with Kevlar Lining",
          accessory: "24k Gold Franco Rope Chain & Vault Key"
        },
        dossier: {
          stronghold: "Room 114 Operations Center (US-80 Frontage)",
          warrants: "Aggravated Assault with Heavy Industrial Machinery, Armed Extortion, Unlicensed Gold Smuggling.",
          tacticalNotes: "Extreme physical resilience and taunt redirection. Counters rapid hitmen; susceptible to high-speed armor-piercing flanks."
        }
      },
      skinny_black: {
        id: "skinny_black",
        name: "Darnell Ross (\"Skinny Black\")",
        callsign: "The Vanguard",
        role: "Syndicate Co-Founder • Highway Logistics & Tactical Flanker",
        category: "ally",
        archetype: "biker",
        threatTier: "CLASS IV: HIGH-VELOCITY REAPER",
        threatClass: "ally",
        avatar: "art/characters/skinny_black.jpg",
        quote: "Headphones on, bass pumping, two Glocks hot. If you blink on 635, you're already in my rearview.",
        stats: {
          attack: 94,
          defense: 64,
          intel: 86,
          agility: 98,
          influence: 85
        },
        skillActive: {
          name: "635 Drive-By",
          cd: "12.0s (Ultimate)",
          desc: "Sprints along the perimeter firing twin extended magazines, striking multiple hostiles for 2.8x burst critical damage."
        },
        skillPassive: {
          name: "Brotherhood Synergy",
          desc: "Whenever Fat Twin's shield is active, Skinny Black gains +50% critical strike damage multiplier."
        },
        loadout: {
          weapon: "Dual Custom Glocks with 33-Round Sticks",
          armor: "Weatherproof Tactical Shell & Kevlar Joggers",
          accessory: "Studio Headphones & Diamond-Cut Gold Rope"
        },
        dossier: {
          stronghold: "The Velvet Lounge & I-635 Highway Corridor",
          warrants: "Felony Speed Contests (>145mph), High-Capacity Weapons Distribution, Evasion of Law Enforcement.",
          tacticalNotes: "Highest attack frequency and burst crit in Mesquite. Lethal flanking mobility; vulnerable to heavy crowd-control."
        }
      },
      mike: {
        id: "mike",
        name: "Big Mike Henderson",
        callsign: "The Wrecker",
        role: "Phase I Boss • Big Town Tow & Salvage Yard Don",
        category: "rival",
        archetype: "bruiser",
        threatTier: "CLASS I: JUNKYARD WARLORD",
        threatClass: "danger",
        avatar: "art/characters/big_mike_henderson.jpg",
        quote: "Everything that crosses into Big Town belongs to my shredder—including your whole crew.",
        stats: {
          attack: 85,
          defense: 88,
          intel: 55,
          agility: 48,
          influence: 62
        },
        skillActive: {
          name: "Tow Chain Slam",
          cd: "10.0s",
          desc: "Swings a 50lb industrial steel tow chain across the frontline, staggering and knocking down opposing bruisers."
        },
        skillPassive: {
          name: "Scrap Armor Hoarder",
          desc: "Gains +2% armor every time scrap is scavenged or an allied minion falls in battle."
        },
        loadout: {
          weapon: "6-Foot Industrial Heavy Steel Pry Bar",
          armor: "Grease-Stained Reinforced Mechanic Coveralls",
          accessory: "Commercial Tow Truck Keyring & Winch Cable"
        },
        dossier: {
          stronghold: "Big Town Salvage & Tow Yard (Sector 1 Border)",
          warrants: "Racketeering, Armed Chop-Shop Operation, Highway Cargo Hijacking, Extortion.",
          tacticalNotes: "Massive frontline damage and chain sweeps. Defeated by exploiting his low agility with high-mobility flankers."
        }
      },
      hector: {
        id: "hector",
        name: "Hector Alvarez (\"The Suit\")",
        callsign: "The Cartel Broker",
        role: "Phase II Boss • Town East Retail Kingpin & Money Launderer",
        category: "rival",
        archetype: "hitman",
        threatTier: "CLASS II: BLACK MARKET FINANCIER",
        threatClass: "danger",
        avatar: "art/characters/hector_the_suit.jpg",
        quote: "Violence without balance sheets is just noise. I buy the judges before I even order the hit.",
        stats: {
          attack: 89,
          defense: 70,
          intel: 96,
          agility: 75,
          influence: 88
        },
        skillActive: {
          name: "Suppressed Burst Execution",
          cd: "11.0s",
          desc: "Fires an armor-piercing burst into the target with the lowest HP percentage, dealing lethal execute damage."
        },
        skillPassive: {
          name: "Shell Company Escrow",
          desc: "Absorbs 20% of incoming physical damage through offshore cash reserves."
        },
        loadout: {
          weapon: "Suppressed Tactical Submachine Gun",
          armor: "Bespoke Three-Piece Pinstripe Suit with Ballistic Vest",
          accessory: "Swiss Chronograph Gold Watch & Offshore Wire Keycard"
        },
        dossier: {
          stronghold: "Town East Mall Luxury Concourse & Vault Penthouse",
          warrants: "International Wire Fraud, Money Laundering, Narcotics Distribution, Bribery.",
          tacticalNotes: "High intelligence and stealth execution. Overwhelm his private security detail with sustained bruiser aggression."
        }
      },
      beau: {
        id: "beau",
        name: "Beau Montgomery (\"The Bull\")",
        callsign: "The Rodeo Warlord",
        role: "Phase III Boss • Mesquite Championship Rodeo & Biker Don",
        category: "rival",
        archetype: "biker",
        threatTier: "CLASS III: OUTLAW HEAVYWEIGHT",
        threatClass: "danger",
        avatar: "art/characters/beau_the_bull.jpg",
        quote: "You stepped into the Arena, boy. Around here, bulls gore the weak and we mount their skulls.",
        stats: {
          attack: 95,
          defense: 84,
          intel: 68,
          agility: 78,
          influence: 82
        },
        skillActive: {
          name: "Stampede Charge",
          cd: "13.0s",
          desc: "Charges with a custom sawed-off double-barrel 12-gauge shotgun, dealing devastating close-range splash damage."
        },
        skillPassive: {
          name: "Texas Grit Frenzy",
          desc: "Attack speed increases by +40% when health drops below 50%."
        },
        loadout: {
          weapon: "Engraved Sawed-Off Double-Barrel 12-Gauge",
          armor: "Hand-Tooled Bullhide Outlaw Biker Cut",
          accessory: "Silver Bull Skull Belt Buckle & Branding Iron"
        },
        dossier: {
          stronghold: "Mesquite Rodeo Arena & Biker Bivouac (Sector 3)",
          warrants: "Underground Bloodsport Promotion, Illegal Firearms Trafficking, Aggravated Battery.",
          tacticalNotes: "Devastating burst splash damage. Stun him during his windup using The Sledge Counter to neutralize his charge."
        }
      },
      vance: {
        id: "vance",
        name: "Director Bill Vance",
        callsign: "The Municipal Tyrant",
        role: "Phase IV Final Boss • Corrupt Police Chief & Municipal Don",
        category: "rival",
        archetype: "police",
        threatTier: "CLASS IV: MUNICIPAL TYRANT",
        threatClass: "danger",
        avatar: "art/characters/director_bill_vance.jpg",
        quote: "In this city, I don't follow the law. I write the warrants. City Hall answers only to me.",
        stats: {
          attack: 92,
          defense: 94,
          intel: 98,
          agility: 65,
          influence: 99
        },
        skillActive: {
          name: "SWAT Tactical Lockdown",
          cd: "16.0s (Ultimate)",
          desc: "Calls in a municipal SWAT tactical strike with flashbangs and suppressive rifle fire, stunning all enemies for 3.0s."
        },
        skillPassive: {
          name: "Qualified Immunity",
          desc: "Immune to all crowd control and stun effects for the first 12 seconds of battle."
        },
        loadout: {
          weapon: "Custom .357 Police Service Revolver with Hollow Points",
          armor: "Municipal Ballistic Trench Coat & Gold Commissioner Badge",
          accessory: "Encrypted Police Radio Dispatch & Mayoral Keycard"
        },
        dossier: {
          stronghold: "City Hall Citadel & Municipal Justice Complex (Sector 4)",
          warrants: "Official Corruption, Extortion, Civil Rights Violations, Evidence Tampering.",
          tacticalNotes: "Extreme defense, immunity window, and squad summons. Must outlast his SWAT call and break his armor."
        }
      }
    };

export let playerProfile = {
      handle: "[ ROOKIE BOSS ]",
      avatar: "art/characters/fat_twin.jpg",
      archetype: "enforcer",
      motto: "From Mesquite Trenches to Riches",
      level: 1,
      rank: "Corner Boss"
    };

export function selectCharacterDossier(charId) {
      playSFX('click');
      selectedDossierId = charId;
      document.querySelectorAll('.dossier-pill-btn').forEach(btn => {
        btn.classList.toggle('active', btn.getAttribute('data-char') === charId);
      });
      renderCharacterDossier(charId);
    }

export function renderCharacterDossier(charId) {
      const container = document.getElementById('character-infographic-card');
      if (!container) return;

      const char = SYNDICATE_CHARACTERS[charId] || SYNDICATE_CHARACTERS.boss;
      const isBoss = (charId === 'boss');
      const displayName = isBoss ? (playerProfile.handle || "Rookie Boss") : char.name;
      const displayAvatar = isBoss ? (playerProfile.avatar || "art/characters/fat_twin.jpg") : char.avatar;
      const displayQuote = isBoss ? (playerProfile.motto || char.quote) : char.quote;
      const displayArchetype = isBoss ? playerProfile.archetype.toUpperCase() : char.archetype.toUpperCase();

      let actionBtnHtml = '';
      if (isBoss) {
        actionBtnHtml = `
          <button onclick="openPlayerSignupModal()" class="war-hud-btn" style="background: rgba(147, 51, 234, 0.35); border-color: var(--accent-purple); color: #e9d5ff; padding: 8px 16px; font-weight: 800; border-radius: 6px; cursor: pointer;">
            ✏️ Edit Boss Alias & Motto
          </button>
          <button onclick="syncStateToD1()" class="war-hud-btn" style="background: rgba(16, 185, 129, 0.25); border-color: #10b981; color: #86efac; padding: 8px 16px; font-weight: 800; border-radius: 6px; cursor: pointer;">
            ☁️ Cloud Sync (D1)
          </button>
        `;
      } else if (char.category === 'rival') {
        actionBtnHtml = `
          <button onclick="challengeBossFromDossier('${charId}')" class="action-btn-small specular-hairline pulse-glow" style="background: linear-gradient(135deg, #ef4444, #b91c1c); color: #fff; font-weight: 900; padding: 10px 20px; border: none; border-radius: 6px; cursor: pointer;">
            ⚔️ CHALLENGE IN ARENA
          </button>
        `;
      } else {
        actionBtnHtml = `
          <button onclick="switchTab('compound')" class="action-btn-small" style="background: rgba(234, 179, 8, 0.25); border: 1px solid var(--accent-gold); color: #fde047; font-weight: 800; padding: 8px 16px; border-radius: 6px; cursor: pointer;">
            🏨 VIEW COMPOUND ROLE
          </button>
        `;
      }

      container.innerHTML = `
        <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 12px; margin-bottom: 20px; border-bottom: 1px solid rgba(255,255,255,0.12); padding-bottom: 14px;">
          <div>
            <div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 4px;">
              <h2 style="font-size: 1.6rem; font-weight: 900; color: #fff; letter-spacing: 0.5px; text-transform: uppercase;">${displayName}</h2>
              <span class="threat-tag ${char.threatClass}">${char.threatTier}</span>
              <span style="background: rgba(147, 51, 234, 0.3); border: 1px solid var(--accent-purple); color: #d8b4fe; font-size: 0.72rem; font-weight: 800; padding: 2px 8px; border-radius: 4px;">${displayArchetype}</span>
            </div>
            <div style="font-size: 0.85rem; color: #94a3b8;">${char.role}</div>
          </div>
          <div style="display: flex; gap: 8px; flex-wrap: wrap;">
            ${actionBtnHtml}
          </div>
        </div>

        <div class="infographic-grid">
          <!-- Col 1: Cinematic Portrait & Audio Wire -->
          <div>
            <div class="infographic-portrait-wrap">
              <img src="${displayAvatar}" alt="${displayName}" class="infographic-portrait-img">
              <div class="infographic-scanlines"></div>
              <div class="infographic-threat-banner">
                <div>
                  <div style="font-size: 0.65rem; color: #94a3b8; font-weight: 800; text-transform: uppercase;">CALLSIGN</div>
                  <div style="font-size: 0.9rem; font-weight: 900; color: #fff;">${char.callsign}</div>
                </div>
                <button onclick="playVoiceBark('${charId}')" style="background: rgba(234, 179, 8, 0.2); border: 1px solid var(--accent-gold); color: #fde047; padding: 4px 10px; border-radius: 4px; font-size: 0.72rem; font-weight: 800; cursor: pointer;">
                  🔊 VOICE WIRE
                </button>
              </div>
            </div>

            <!-- Stylized Quote Box -->
            <div style="margin-top: 14px; background: rgba(15, 23, 42, 0.8); border: 1px solid rgba(255,255,255,0.1); border-left: 3px solid var(--accent-gold); border-radius: 6px; padding: 12px 14px; font-style: italic; font-size: 0.82rem; color: #cbd5e1; line-height: 1.4;">
              "${displayQuote}"
            </div>
          </div>

          <!-- Col 2: Telemetry Radar & Stat Meters -->
          <div>
            <div class="infographic-module-box">
              <div class="infographic-module-title">
                <span>📊</span><span>COMBAT TELEMETRY & STAT RADAR</span>
              </div>

              <!-- Attack -->
              <div class="infographic-metric-item">
                <div class="infographic-metric-header">
                  <span style="color: #f43f5e;">🗡️ LETHALITY / ATTACK POWER</span>
                  <span style="color: #fff;">${char.stats.attack} / 100</span>
                </div>
                <div class="infographic-meter-track">
                  <div class="infographic-meter-fill" style="width: ${char.stats.attack}%; background: linear-gradient(90deg, #f43f5e, #fb7185);"></div>
                </div>
              </div>

              <!-- Defense -->
              <div class="infographic-metric-item">
                <div class="infographic-metric-header">
                  <span style="color: #38bdf8;">🛡️ KINETIC ARMOR / DEFENSE</span>
                  <span style="color: #fff;">${char.stats.defense} / 100</span>
                </div>
                <div class="infographic-meter-track">
                  <div class="infographic-meter-fill" style="width: ${char.stats.defense}%; background: linear-gradient(90deg, #0284c7, #38bdf8);"></div>
                </div>
              </div>

              <!-- Intel / Laundering -->
              <div class="infographic-metric-item">
                <div class="infographic-metric-header">
                  <span style="color: #22c55e;">🧠 TACTICAL INTEL & LAUNDERING</span>
                  <span style="color: #fff;">${char.stats.intel} / 100</span>
                </div>
                <div class="infographic-meter-track">
                  <div class="infographic-meter-fill" style="width: ${char.stats.intel}%; background: linear-gradient(90deg, #10b981, #4ade80);"></div>
                </div>
              </div>

              <!-- Agility -->
              <div class="infographic-metric-item">
                <div class="infographic-metric-header">
                  <span style="color: #c084fc;">⚡ HIGHWAY AGILITY & VELOCITY</span>
                  <span style="color: #fff;">${char.stats.agility} / 100</span>
                </div>
                <div class="infographic-meter-track">
                  <div class="infographic-meter-fill" style="width: ${char.stats.agility}%; background: linear-gradient(90deg, #9333ea, #c084fc);"></div>
                </div>
              </div>

              <!-- Influence -->
              <div class="infographic-metric-item">
                <div class="infographic-metric-header">
                  <span style="color: #fde047;">👑 STREET CRED & INFLUENCE</span>
                  <span style="color: #fff;">${char.stats.influence} / 100</span>
                </div>
                <div class="infographic-meter-track">
                  <div class="infographic-meter-fill" style="width: ${char.stats.influence}%; background: linear-gradient(90deg, #ca8a04, #fde047);"></div>
                </div>
              </div>

              <div style="margin-top: 14px; padding: 8px 12px; background: rgba(0,0,0,0.4); border-radius: 6px; display: flex; justify-content: space-between; align-items: center; border: 1px solid rgba(255,255,255,0.08);">
                <span style="font-size: 0.72rem; color: #94a3b8; font-weight: 800;">CALCULATED POWER RATING:</span>
                <span style="font-size: 0.95rem; font-weight: 900; color: var(--accent-gold);">${(char.stats.attack * 15 + char.stats.defense * 12 + char.stats.intel * 10 + char.stats.agility * 8).toLocaleString()} PTS</span>
              </div>
            </div>

            <!-- Signature Skills -->
            <div class="infographic-module-box">
              <div class="infographic-module-title">
                <span>⚡</span><span>SIGNATURE COMBAT TRAITS</span>
              </div>
              <div style="margin-bottom: 10px;">
                <div style="display: flex; justify-content: space-between; font-size: 0.78rem; font-weight: 800; color: #fff; margin-bottom: 2px;">
                  <span style="color: var(--accent-gold);">ACTIVE: ${char.skillActive.name}</span>
                  <span style="color: #94a3b8; font-size: 0.72rem;">CD: ${char.skillActive.cd}</span>
                </div>
                <div style="font-size: 0.74rem; color: #cbd5e1; line-height: 1.35;">${char.skillActive.desc}</div>
              </div>
              <div>
                <div style="font-size: 0.78rem; font-weight: 800; color: #86efac; margin-bottom: 2px;">
                  PASSIVE: ${char.skillPassive.name}
                </div>
                <div style="font-size: 0.74rem; color: #cbd5e1; line-height: 1.35;">${char.skillPassive.desc}</div>
              </div>
            </div>
          </div>

          <!-- Col 3: Weapon Loadout & Dallas County Rap Sheet -->
          <div>
            <!-- Equipment Loadout -->
            <div class="infographic-module-box">
              <div class="infographic-module-title">
                <span>⚔️</span><span>TACTICAL LOADOUT</span>
              </div>
              <div style="display: flex; flex-direction: column; gap: 8px;">
                <div style="background: rgba(0,0,0,0.4); border: 1px solid rgba(255,255,255,0.08); border-radius: 6px; padding: 8px 10px;">
                  <div style="font-size: 0.65rem; color: #94a3b8; font-weight: 800;">PRIMARY WEAPON</div>
                  <div style="font-size: 0.82rem; font-weight: 800; color: #fff;">${char.loadout.weapon}</div>
                </div>
                <div style="background: rgba(0,0,0,0.4); border: 1px solid rgba(255,255,255,0.08); border-radius: 6px; padding: 8px 10px;">
                  <div style="font-size: 0.65rem; color: #94a3b8; font-weight: 800;">DEFENSIVE GEAR</div>
                  <div style="font-size: 0.82rem; font-weight: 800; color: #fff;">${char.loadout.armor}</div>
                </div>
                <div style="background: rgba(0,0,0,0.4); border: 1px solid rgba(255,255,255,0.08); border-radius: 6px; padding: 8px 10px;">
                  <div style="font-size: 0.65rem; color: #94a3b8; font-weight: 800;">SPECIAL ACCREDITATION</div>
                  <div style="font-size: 0.82rem; font-weight: 800; color: #fff;">${char.loadout.accessory}</div>
                </div>
              </div>
            </div>

            <!-- Dallas County Rap Sheet -->
            <div class="infographic-module-box">
              <div class="infographic-module-title">
                <span>🚨</span><span>DALLAS COUNTY SHERIFF DOSSIER</span>
              </div>
              <div style="font-size: 0.72rem; color: #94a3b8; font-weight: 800; margin-bottom: 2px;">STRONGHOLD SECTOR</div>
              <div style="font-size: 0.78rem; color: #fff; font-weight: 700; margin-bottom: 8px;">${char.dossier.stronghold}</div>
              
              <div style="font-size: 0.72rem; color: #ef4444; font-weight: 800; margin-bottom: 2px;">ACTIVE CHARGES & WARRANTS</div>
              <div style="font-size: 0.74rem; color: #cbd5e1; line-height: 1.35; margin-bottom: 8px;">${char.dossier.warrants}</div>

              <div style="font-size: 0.72rem; color: #38bdf8; font-weight: 800; margin-bottom: 2px;">TACTICAL ASSESSMENT</div>
              <div style="font-size: 0.74rem; color: #cbd5e1; line-height: 1.35;">${char.dossier.tacticalNotes}</div>
            </div>
          </div>
        </div>
      `;
    }

export function challengeBossFromDossier(bossKey) {
      playSFX('tab_switch');
      if (typeof switchTab === 'function') switchTab('arena');
      else if (window.switchTab) window.switchTab('arena');
      if (typeof selectBoss === 'function') selectBoss(bossKey);
      else if (window.selectBoss) window.selectBoss(bossKey);
      const el = document.getElementById('tab-arena');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }

export function initPlayerProfile() {
      try {
        const saved = localStorage.getItem("mesquite_boss_profile");
        if (saved) {
          playerProfile = Object.assign(playerProfile, JSON.parse(saved));
        }
        const storedHandle = localStorage.getItem("mesquite_player_handle");
        if (storedHandle && storedHandle !== "UNREGISTERED BOSS" && !storedHandle.toLowerCase().includes("micah")) {
          playerProfile.handle = storedHandle;
        } else if (!saved) {
          playerProfile.handle = "[ ROOKIE BOSS ]";
        }
      } catch(e) {}

      updateProfileUI();
    }

export function updateProfileUI() {
      const isRookie = !playerProfile.handle || playerProfile.handle === "UNREGISTERED BOSS" || playerProfile.handle === "[ ROOKIE BOSS ]";
      const headerHandle = document.getElementById('player-handle');
      if (headerHandle) headerHandle.innerText = isRookie ? "[ ROOKIE BOSS ]" : playerProfile.handle;
      const headerAvatar = document.getElementById('header-avatar-img');
      if (headerAvatar) headerAvatar.src = playerProfile.avatar || "art/characters/fat_twin.jpg";
      const headerTag = document.getElementById('player-archetype-tag');
      if (headerTag) headerTag.innerText = (playerProfile.archetype || 'enforcer').toUpperCase();

      const syncStatus = document.getElementById('sync-status');
      if (syncStatus) {
        const token = localStorage.getItem("mesquite_session_token");
        if (token) {
          syncStatus.innerText = "● CLOUD SYNCED";
          syncStatus.style.color = "#10b981";
        } else {
          syncStatus.innerText = "● GUEST SESSION";
          syncStatus.style.color = "#fbbf24";
        }
      }

      // Update Dossier Selector Bar active pill
      const pillName = document.getElementById('pill-name-boss');
      if (pillName) pillName.innerText = isRookie ? "MY BOSS DOSSIER" : playerProfile.handle.toUpperCase();
      const pillAvatar = document.getElementById('pill-avatar-boss');
      if (pillAvatar) pillAvatar.src = playerProfile.avatar || "art/characters/fat_twin.jpg";

      renderCharacterDossier(selectedDossierId || 'boss');

      const pLevel = document.getElementById('profile-level-num');
      if (pLevel) pLevel.innerText = state.level || 1;
      const pXp = document.getElementById('profile-xp-num');
      if (pXp) pXp.innerText = (state.xp || 0).toLocaleString();
      const pXpNext = document.getElementById('profile-xp-next-num');
      if (pXpNext) pXpNext.innerText = (state.xpToNext || 250).toLocaleString();
      const pXpFill = document.getElementById('profile-xp-fill');
      if (pXpFill) {
        const pct = Math.min(100, Math.round(((state.xp || 0) / (state.xpToNext || 250)) * 100));
        pXpFill.style.width = pct + '%';
      }

      const sNet = document.getElementById('stat-net-worth');
      if (sNet) {
        const total = (state.cash || 0) + ((state.cred || 0) * 10);
        sNet.innerText = '$' + total.toLocaleString();
      }
      const sHeat = document.getElementById('stat-heat');
      if (sHeat) {
        const heat = state.policeHeat || 0;
        sHeat.innerText = '⭐'.repeat(heat) + '☆'.repeat(5 - heat) + ` (${heat} Stars)`;
      }
      const sConvoys = document.getElementById('stat-convoys');
      if (sConvoys) {
        const active = (state.convoys || []).filter(c => c.active).length;
        sConvoys.innerText = `${active} In Transit`;
      }
    }

export function openPlayerProfile() {
      switchTab('profile');
      updateProfileUI();
    }

export function selectAvatarCard(el) {
      playSFX('click');
      document.querySelectorAll('.avatar-choice-card').forEach(c => c.classList.remove('active'));
      el.classList.add('active');
    }

export function selectArchetypeCard(el) {
      playSFX('click');
      document.querySelectorAll('.archetype-card').forEach(c => c.classList.remove('active'));
      el.classList.add('active');
    }

export function randomizeBossHandle() {
      playSFX('click');
      const names = [
        "Galloway_Ghost", "Viper_635", "Shadow_Don", "Mesquite_Outlaw",
        "Dallas_Phantom", "Iron_Reaper", "Neon_Kingpin", "Highway_Wolf",
        "Deadlock_Don", "635_Striker", "Apex_Predator", "Concrete_King"
      ];
      const picked = names[Math.floor(Math.random() * names.length)];
      const input = document.getElementById('input-player-handle');
      if (input) input.value = picked;
    }

export async function savePlayerProfile() {
      playSFX('vault');
      const inputHandle = document.getElementById('input-player-handle');
      const inputMotto = document.getElementById('input-player-motto');
      const activeAvatarCard = document.querySelector('#modal-player-signup .avatar-choice-card.active');
      const activeArchCard = document.querySelector('#modal-player-signup .archetype-card.active');
      const errEl = document.getElementById('signup-modal-error');

      const rawHandle = inputHandle ? inputHandle.value.trim() : "";
      if (!rawHandle || rawHandle.length < 3) {
        if (errEl) {
          errEl.innerText = "⚠️ Boss Alias must be at least 3 characters long.";
          errEl.style.display = 'block';
        }
        return;
      }

      playerProfile.handle = rawHandle;
      if (inputMotto && inputMotto.value.trim()) {
        playerProfile.motto = inputMotto.value.trim();
      }
      if (activeAvatarCard) {
        playerProfile.avatar = activeAvatarCard.getAttribute('data-avatar') || playerProfile.avatar;
      }
      if (activeArchCard) {
        playerProfile.archetype = activeArchCard.getAttribute('data-archetype') || playerProfile.archetype;
      }

      localStorage.setItem("mesquite_boss_profile", JSON.stringify(playerProfile));
      localStorage.setItem("mesquite_player_handle", playerProfile.handle);

      try {
        const resp = await fetch("/api/auth", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            username: playerProfile.handle,
            archetype: playerProfile.archetype
          })
        });
        if (resp.ok) {
          const data = await resp.json();
          if (data.sessionToken) {
            localStorage.setItem("mesquite_session_token", data.sessionToken);
          }
          if (data.currencies) {
            state.cash = data.currencies.dirty_cash;
            state.product = data.currencies.product_bags;
            state.scrap = data.currencies.scrap_hardware;
            state.cred = data.currencies.street_cred;
            updateCurrencies();
          }
          if (data.player && data.player.compound_level) {
            state.compoundLevel = data.player.compound_level;
          }
          if (data.player && data.player.missions_state_json) {
            try {
              hydrateMissionsFromSaved(JSON.parse(data.player.missions_state_json));
            } catch(e) {}
          }
        }
      } catch(e) {
        log("[DOSSIER]: Offline registration active.");
      }

      updateProfileUI();
      closePlayerSignupModal();
      enterGame();

      playActionSequence({
        title: "SYNDICATE IDENTITY SECURED",
        icon: "👑",
        detail: `Boss ${playerProfile.handle} profile synced to Mesquite ledger!`,
        rewardText: "Cloud Persisted • Room 114 Operations Center Active",
        shots: 2
      });
      log(`[DOSSIER]: Registered syndicate boss "${playerProfile.handle}".`);
    }

